export default __webpack_public_path__ + "images/AOA.b09d002.png";